<div class="wage-calc-steps">
  <h5 class="wage-calc-steps__title">{{ title }}</h5>

  <div class="wage-calc-steps__row" *ngFor="let step of steps">
    <span class="wage-calc-steps__label">{{ step.label }}</span>
    <span class="wage-calc-steps__operands">{{ step.operands }}</span>
    <span class="wage-calc-steps__equal">=</span>
    <span class="wage-calc-steps__result">{{ step.result }}</span>
    <span class="wage-calc-steps__unit">{{ step.unit }}</span>
    <span class="wage-calc-steps__description">{{ step.description }}</span>
  </div>
</div>
